import { BaseProfilEcriture } from '@mairistem/finances-utils';
import ImpactCollectivitePanel from '@/src/classes/Panel/ImpactCollectivitePanel';
import ImpactEnvironnementPanel from '@/src/classes/Panel/ImpactEnvironnementPanel';
import ResumePanel from '@/src/classes/Panel/ResumePanel';

class BaseProfilEcritureProjet extends BaseProfilEcriture {
	constructor() {
		super();
		this.panels = [
			new ResumePanel(false),
			new ImpactCollectivitePanel(false),
			new ImpactEnvironnementPanel(false),
		];
	}
}

export default BaseProfilEcritureProjet;
